var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
import React, { forwardRef } from 'react';
import { propTypes } from './types';
import './NxBinaryDonutChart.scss';
import classnames from 'classnames';
var NxBinaryDonutChart = forwardRef(function NxBinaryDonutChart(props, ref) {
    var innerRadiusPercent = props.innerRadiusPercent, percent = props.percent, className = props.className, svgAttrs = __rest(props, ["innerRadiusPercent", "percent", "className"]);
    var donutClasses = classnames('nx-binary-donut-chart', className);
    var innerRadiusPercentNotNull = innerRadiusPercent == null ? 50 :
        innerRadiusPercent < 0 ? 0 :
            innerRadiusPercent > 100 ? 100 :
                innerRadiusPercent;
    var strokeWidth = 100 - innerRadiusPercentNotNull;
    var r = innerRadiusPercentNotNull + (strokeWidth / 2);
    // Add 0.5π because we want the angle from the top of the circle, not the right
    var arcEndAngle = (Math.PI / 2) + (2 * Math.PI * (percent / 100));
    // Multiply by -1 to fill clockwise not counter-clockwise
    var arcEndX = -1 * r * Math.cos(arcEndAngle);
    // Multiply by -1 because the y value increases going downwards on the screen, not upwards
    var arcEndY = -1 * r * Math.sin(arcEndAngle);
    var largeArc = percent > 50 ? 1 : 0;
    return (React.createElement("svg", __assign({ ref: ref, viewBox: "-100 -100 200 200", role: "img", className: donutClasses }, svgAttrs),
        percent < 100 &&
            React.createElement("circle", { className: "nx-binary-donut-chart__background", strokeWidth: strokeWidth, r: r }),
        percent > 0 && percent < 100 &&
            React.createElement("path", { className: "nx-binary-donut-chart__arc", d: "M 0 " + -r + " A " + r + " " + r + " 0 " + largeArc + " 1 " + arcEndX + " " + arcEndY, strokeWidth: strokeWidth }),
        percent >= 100 &&
            React.createElement("circle", { className: "nx-binary-donut-chart__arc", strokeWidth: strokeWidth, r: r })));
});
NxBinaryDonutChart.propTypes = propTypes;
export default NxBinaryDonutChart;
//# sourceMappingURL=NxBinaryDonutChart.js.map